export interface ResearchExportColumn {
  key: string;
  label: string;
  desc: string;
  required: boolean;
}

export interface ResearchExportColumnGroup {
  group: string;
  items: ResearchExportColumn[];
}

export const RESEARCH_EXPORT_COLUMNS: ResearchExportColumnGroup[] = [
  { group: 'Identity', items: [
    { key: 'student_id',  label: 'student_id',  desc: 'Anonymised student identifier',  required: true  },
    { key: 'school_name', label: 'school_name', desc: 'Name of the school',             required: false },
    { key: 'grade',       label: 'grade',       desc: 'Student grade level',            required: false },
    { key: 'group_id',    label: 'group_id',    desc: 'Anonymised group identifier',    required: false },
  ]},
  { group: 'Skill', items: [
    { key: 'skill_group', label: 'skill_group', desc: 'Skill group or sub-skill name', required: true },
  ]},
  { group: 'Mastery', items: [
    { key: 'mastery_start', label: 'mastery_start', desc: 'Mastery at first record in school year (0 to 1)',       required: false },
    { key: 'mastery_end',   label: 'mastery_end',   desc: 'Mastery at most recent record in school year (0 to 1)', required: false },
    { key: 'mastery_delta', label: 'mastery_delta', desc: 'Change in mastery across the school year',              required: false },
  ]},
  { group: 'Dates', items: [
    { key: 'first_active_date', label: 'first_active_date', desc: 'Date of first activity on this skill in the school year', required: false },
    { key: 'last_active_date',  label: 'last_active_date',  desc: 'Date of most recent activity on this skill',              required: false },
    { key: 'num_days_active',   label: 'num_days_active',   desc: 'Number of distinct days active on this skill',            required: false },
  ]},
  { group: 'Usage', items: [
    { key: 'num_answers',  label: 'num_answers',  desc: 'Total answers submitted on this skill across the year',     required: false },
    { key: 'num_correct',  label: 'num_correct',  desc: 'Total correct answers',                                     required: false },
    { key: 'num_wrong',    label: 'num_wrong',    desc: 'Total incorrect answers',                                   required: false },
    { key: 'correct_rate', label: 'correct_rate', desc: 'Percentage of correct answers (num_correct / num_answers)', required: false },
  ]},
];

export type ResearchExportSkillGranularity = 'skillGroup' | 'subSkill';
export type ResearchExportActivityPeriod = 'weekly' | 'monthly';
export type ResearchExportScope = 'schools' | 'all';

export class ResearchExportPayload {

  scope: ResearchExportScope = 'schools';
  schoolIds: string[] = [];

  includeSkillSummary = true;
  skillGranularity: ResearchExportSkillGranularity = 'skillGroup';
  columns: string[] = RESEARCH_EXPORT_COLUMNS.reduce((keys, g) => keys.concat(g.items.map(c => c.key)), []);

  includeActivity = true;
  activityPeriod: ResearchExportActivityPeriod = 'monthly';

  includeGroupSummary = true;
  groupGranularity: ResearchExportSkillGranularity = 'skillGroup';

  includeSchoolName = true;
  includeGroupName = true;
  excludeLowActivityStudents = false;
}
